import { render, staticRenderFns } from "./extraList.vue?vue&type=template&id=325ebc73&scoped=true&"
import script from "./extraList.ts?vue&type=script&lang=js&"
export * from "./extraList.ts?vue&type=script&lang=js&"
import style0 from "./extraList.less?vue&type=style&index=0&id=325ebc73&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325ebc73",
  null
  
)

export default component.exports